import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-button',
  styleUrls: ['button.component.scss'],
  template: `
    <button [ngClass]="BEM" [disabled]="disabled" type="button">
      <svg *ngIf="iconLeft"><use [attr.xlink:href]="'assets/symbol/svg/sprite.css.svg' + iconLeft"></use></svg>
      <img *ngIf="imgIcon" src="{{imgIcon}}" />
      <span><ng-content></ng-content></span>
      <svg *ngIf="iconRight"><use [attr.xlink:href]="'assets/symbol/svg/sprite.css.svg' + iconRight"></use></svg>
    </button>
  `
})
export class ButtonComponent {
  /**
   * Visual type of the button. Omit if primary type.
   */
  @Input() type: 'secondary' | 'primary' | 'dark' | 'link' = 'primary';
  /**
   * Size of the button (sm | lg). Omit if medium size.
   */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  /**
   * Name of the icon we want to show on the left.
   */
  @Input() iconLeft?: string;
  /**
   * Name of the icon we want to show on the right.
   */
  @Input() iconRight?: string;

  /**
   * Optional full url to a img icon.
   */
  @Input() imgIcon?: string;
  /**
   * If the button is disabled.
   */
  @Input() disabled?: boolean;
  /*
    Allow text break
  */
  @Input() enableWrap?: boolean;

  constructor() {}

  get BEM(): string[] {
    const stringArray: string[] = ['app-button'];

    stringArray.push(`app-button--${this.type}`);

    stringArray.push(`app-button--${this.size}`);

    if (this.enableWrap) {
      stringArray.push(`app-button--wrap`);
    }

    return stringArray;
  }
}
